import { Component } from "react";

// Class component because React has no hook equivalent for componentDidCatch.
// Without this a single thrown render blanks the whole site.
class ErrorBoundary extends Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error("Unhandled render error:", error, info);
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        return (
            <div
                role="alert"
                className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center"
            >
                <h1 className="md:text-3xl mb-3 text-2xl text-red-500">
                    Something went wrong.
                </h1>
                <p className="mb-6 text-sm">
                    Please reload the page. If it keeps happening, email{" "}
                    <a
                        href="mailto:harmain@softec.org.pk"
                        className="text-blue-500 underline"
                    >
                        harmain@softec.org.pk
                    </a>
                    .
                </p>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="focus:outline-none focus:ring-2 focus:ring-red-400 px-4 py-2 text-sm text-white bg-red-500 rounded"
                >
                    Reload
                </button>
            </div>
        );
    }
}

export default ErrorBoundary;
